import { loadSessionsForDate } from '../../actions/dateSessions';
import {
    setSection,
    setSelectedDate,
    setSelectedSessionId,
    setShouldShowTicketError,
    setShouldShowTimeError,
    setTicketSectionLoading,
} from '../../actions/infiniteCalendarSeries';
import { navigateToTicketSelection } from '../../actions/initialize';
import { HeapEventName } from '../../constants/heap/events';
import {
    AccordionSection,
    CalendarType,
} from '../../state/infiniteCalendarSeries';

export const handleDateSelect = async ({
    dateString,
    calendarType,
    eventId,
    sessionTime,
    dispatch,
    track,
}: {
    dateString: string;
    calendarType: CalendarType;
    eventId?: string;
    sessionTime?: string;
    dispatch: (
        action: { type: string; payload: any } | any,
    ) => Promise<any> | void;
    track: (event: {
        eventName: string;
        eventData: {
            selectedOption: string;
            isSeriesInfiniteCalendar: boolean;
        };
    }) => void;
}) => {
    const isCompactWithSessionCalendar =
        calendarType === CalendarType.compactWithSession;

    track({
        eventName: HeapEventName.timedEntryDateSelectorClick,
        eventData: {
            selectedOption: dateString,
            isSeriesInfiniteCalendar: true,
        },
    });

    if (isCompactWithSessionCalendar && eventId) {
        dispatch(setSelectedDate(sessionTime || ''));
        await handleTicketSelectionFlow({ eventId, dispatch });
    } else {
        dispatch(setSelectedDate(dateString || ''));
        dispatch(loadSessionsForDate(dateString));
        dispatch(setSection(AccordionSection.time));
        dispatch(setShouldShowTimeError(false));
        dispatch(setShouldShowTicketError(false));
    }
};

export const handleTicketSelectionFlow = async ({
    eventId,
    dispatch,
}: {
    eventId: string;
    dispatch: (action: any) => Promise<any> | void;
}) => {
    dispatch(setSelectedSessionId(eventId));
    dispatch(setTicketSectionLoading(true));
    dispatch(setSection(AccordionSection.tickets));
    await dispatch(navigateToTicketSelection(eventId));
    dispatch(setTicketSectionLoading(false));
    dispatch(setShouldShowTicketError(false));
};
